import React from 'react';
import { Container } from 'react-bootstrap';
import { ToastContainer } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';
import styles from './App.module.scss';
import HomePage from './pages/HomePage';

function App() {
  return (
    <>
      <div className={styles.appContainer}>
        <Container>
          <HomePage />
        </Container>
      </div>
      
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
}

export default App;
